import FetchStatus from "@/constants/fetch-status/FetchStatus";

/**
 * Cria uma model para consultar ResultSet na base.
 * @param {object} - objeto necessário para requisição http
 * - monitoringElementId id do elemento de monitoração ad turbina.
 * - startDateTime Data de inicio da pesquisa.
 * - endDateTime Data final da pesquisa.
 * @returns Objeto para requisição.
 */
const ResultSetModel = function({
	monitoringElementId = 0,
	startDateTime = new Date(),
	endDateTime = new Date()
})
{
	return {
		monitoringElementId: monitoringElementId,
		startDateTime:       startDateTime,
		endDateTime:         endDateTime,
	};
};

/**
 * Cria o state para vuex da matriz diagnóstico
 * - error - erro ao usar alguma action do vuex.
 * - status - status da requisição http.
 * - data - Array principal de resultados.
 * - stage2ResultSets - Array de resultados para as falhas do estágio 2 da gearbox.
 * - stage3ResultSets - Array de resultados para as falhas do estágio 3 da gearbox.
 * - planetaryResultSets - Array de resultados de diagnóstico das planetárias.
 * - parallelMisalignmentHssResultSets - Array de resultados p/ desalinhamento paralelo de eixo de alta velocidade (HSS)
 * - angularMisalignmentHssResultSets - Array de resultados p/ desalinhamento angular de eixo de alta velocidade (HSS)
 * - bearingsResultSets - Array de resultados de falhas relacionados a rolamentos.
 * - loosenessResultSets - Array de resultados para  folga nos mancais.
 * - imbalanceMainShaftResultSets - Array de resultados para desbalanceamento do eixo principal.
 * - angularMisalignmentResultSets - Array de resultados para desalinhamento angular.
 * - parallelMisalignmentResultSets - Array de resultados para desalinhamento paralelo.
 * - parallelMisalignmentGeneratorShaftResultSets - Array de resultados para desalinhamento paralelo do eixo do gerador.
 * - generatorShaftUnbalanceResultSets - Array de resultados para desbalanceamento do eixo do gerador.
 * - generatorElectricFail - Array de resultados para falhas elétricas do gerador.
 * - angularMisalignmentHssResultSets - Array de resultados para desalinhamento angular de eixo de alta velocidade (HSS)
 * - parallelMisalignmentHssResultSets - Array de resultados para desalinhamento paralelo de eixo do (HSS).
 * - generatorUpWindBearingResultSets - Array de resultados para rolamento de gerador down wind.
 * - generatorDownWindBearingResultSets - Array de resultados para rolamento de gerador up wind.
 * - gearboxHSSUpWindBearingResultSets - Array de resultados para rolamento HSS da gearbox down wind.
 * - gearboxHSSDownWindUpBearingResultSets - Array de resultados para rolamento superior HSS da gearbox up wind.
 * - gearboxHSSDownWindDownBearingResultSets - Array de resultados para rolamento inferior HSS da gearbox up wind.
 * - gearboxIMSUpWindBearingResultSets - Array de resultados para rolamento IMS da gearbox down wind.
 * - gearboxIMSDownWindBearingResultSets - Array de resultados para rolamento IMS da gearbox up wind.
 * - gearboxLSSUpWindBearingResultSets - Array de resultados para rolamento LSS da gearbox down wind.
 * - gearboxLSSDownWindUpBearingResultSets - Array de resultados para rolamento superior LSS da gearbox up wind.
 * - gearboxLSSDownWindDownBearingResultSets - Array de resultados para rolamento inferior LSS da gearbox up wind.
 * - gearboxPlanetaryBearingResultSets - Array de resultados para rolamento planetário da gearbox.
 * - gearboxPlanetaryDownWindBearingResultSets - Array de resultados para rolamento planetário da gearbox up wind.
 * - gearboxPlanetaryUpWindBearingResultSets - Array de resultados para rolamento planetário da gearbox down wind.
 * - mainShaftBearingResultSets - Array de resultados para rolamento do eixo principal.
 * - mainShaftUpWindBearingResultSets - Array de resultados para rolamento do eixo principal down wind.
 * - mainShaftDownWindBearingResultSets - Array de resultados para rolamento do eixo principal up wind.
 * @returns O state contendo todas as propriedades do vuex da matriz diagnóstico
 */
const ResultSetsState = function()
{
	return {
		error:                                     {},
		status:                                    FetchStatus.Init,
		data:                                      [],
		stage2ResultSets:                          [],
		stage3ResultSets:                          [],
		planetaryResultSets:                       [],
		loosenessResultSets:                       [],
		angularMisalignmentHssResultSets:          [],
		parallelMisalignmentHssResultSets:         [],
		mainShaftUnbalanceResultSets:              [],
		generatorShaftUnbalanceResultSets:         [],
		angularMisalignmentResultSets:             [],
		parallelMisalignmentResultSets:            [],
		generatorElectricFail:                     [],
		bearingsResultSets:                        [],
		generatorUpWindBearingResultSets:          [],
		generatorDownWindBearingResultSets:        [],
		gearboxHSSUpWindBearingResultSets:         [],
		gearboxHSSDownWindUpBearingResultSets:     [],
		gearboxHSSDownWindDownBearingResultSets:   [],
		gearboxIMSUpWindBearingResultSets:         [],
		gearboxIMSDownWindBearingResultSets:       [],
		gearboxLSSUpWindBearingResultSets:         [],
		gearboxLSSDownWindUpBearingResultSets:     [],
		gearboxLSSDownWindDownBearingResultSets:   [],
		gearboxPlanetaryBearingResultSets:         [],
		gearboxPlanetaryDownWindBearingResultSets: [],
		gearboxPlanetaryUpWindBearingResultSets:   [],
		mainShaftBearingResultSets:                [],
		mainShaftUpWindBearingResultSets:          [],
		mainShaftDownWindBearingResultSets:        [],
	};
};

/**
 * Cria uma view dos conjuntos de resultados a partir do objeto fornecido.
 *
 * @param {object} obj - O objeto de entrada contendo diferentes conjuntos de resultados.
 * - mainResultSetsList - Array principal de resultados.
 * - stage2ResultSets - Array de resultados para as falhas do estágio 2 da gearbox.
 * - stage3ResultSets - Array de resultados para as falhas do estágio 3 da gearbox.
 * - planetaryResultSets - Array de resultados de diagnóstico das planetárias.
 * - parallelMisalignmentHssResultSets - Array de resultados p/ desalinhamento paralelo de eixo de alta velocidade (HSS)
 * - angularMisalignmentHssResultSets - Array de resultados p/ desalinhamento angular de eixo de alta velocidade (HSS)
 * - bearingsResultSets - Array de resultados de falhas relacionados a rolamentos.
 * - loosenessResultSets - Array de resultados para  folga nos mancais.
 * - imbalanceMainShaftResultSets - Array de resultados para desbalanceamento do eixo principal.
 * - angularMisalignmentResultSets - Array de resultados para desalinhamento angular.
 * - parallelMisalignmentResultSets - Array de resultados para desalinhamento paralelo.
 * - parallelMisalignmentGeneratorShaftResultSets - Array de resultados para desalinhamento paralelo do eixo do gerador.
 * - generatorShaftUnbalanceResultSets - Array de resultados para desbalanceamento do eixo do gerador.
 * - generatorElectricFail - Array de resultados para falhas elétricas do gerador.
 * @returns Um objeto contendo todos os conjuntos de resultados,
 *  com valores padrão como arrays vazios caso não sejam fornecidos.
 */
const FilteredResultSetView = function(obj)
{
	return {
		mainResultSetsList:                           obj.mainResultSetsList || new Array(0),
		stage2ResultSets:                             obj.stage2ResultSets || new Array(0),
		stage3ResultSets:                             obj.stage3ResultSets || new Array(0),
		planetaryResultSets:                          obj.planetaryResultSets || new Array(0),
		parallelMisalignmentHssResultSets:            obj.parallelMisalignmentHssResultSets || new Array(0),
		angularMisalignmentHssResultSets:             obj.angularMisalignmentHssResultSets || new Array(0),
		bearingsResultSets:                           obj.bearingsResultSets || new Array(0),
		loosenessResultSets:                          obj.loosenessResultSets || new Array(0),
		imbalanceMainShaftResultSets:                 obj.imbalanceMainShaftResultSets || new Array(0),
		angularMisalignmentResultSets:                obj.angularMisalignmentResultSets || new Array(0),
		parallelMisalignmentResultSets:               obj.parallelMisalignmentResultSets || new Array(0),
		parallelMisalignmentGeneratorShaftResultSets: obj.parallelMisalignmentGeneratorShaftResultSets || new Array(0),
		generatorShaftUnbalanceResultSets:            obj.generatorShaftUnbalanceResultSets || new Array(0),
		generatorElectricFail:                        obj.generatorElectricFail || new Array(0),
	};
};

/**
 * Cria uma view dos piores resultados, fornecendo dados padronizados caso não sejam especificados.
 *
 * - mainResultSetsList - Array principal do de resultados.
 * - stage2ResultSets - Array de resultados para as falhas do estágio 2 da gearbox.
 * - stage3ResultSets - Array de resultados para as falhas do estágio 3 da gearbox.
 * - planetaryResultSets - Array de resultados de diagnóstico das planetárias.
 * - parallelMisalignmentHssResultSets - Array de resultados p/ desalinhamento paralelo de eixo de alta velocidade (HSS)
 * - angularMisalignmentHssResultSets - Array de resultados p/ desalinhamento angular de eixo de alta velocidade (HSS)
 * - bearingsResultSets - Array de resultados de falhas relacionados a rolamentos.
 * - loosenessResultSets - Array de resultados para  folga nos mancais.
 * - imbalanceMainShaftResultSets - Array de resultados para desbalanceamento do eixo principal.
 * - angularMisalignmentResultSets - Array de resultados para desalinhamento angular.
 * - parallelMisalignmentResultSets - Array de resultados para desalinhamento paralelo.
 * - parallelMisalignmentGeneratorShaftResultSets - Array de resultados para desalinhamento paralelo do eixo do gerador.
 * - generatorShaftUnbalanceResultSets - Array de resultados para desbalanceamento do eixo do gerador.
 * - generatorElectricFail - Array de resultados para falhas elétricas do gerador.
 * - angularMisalignmentHssResultSets - Array de resultados para desalinhamento angular de eixo de alta velocidade (HSS)
 * - parallelMisalignmentHssResultSets - Array de resultados para desalinhamento paralelo de eixo do (HSS).
 * - generatorUpWindBearingResultSets - Array de resultados para rolamento de gerador down wind.
 * - generatorDownWindBearingResultSets - Array de resultados para rolamento de gerador up wind.
 * - gearboxHSSUpWindBearingResultSets - Array de resultados para rolamento HSS da gearbox down wind.
 * - gearboxHSSDownWindUpBearingResultSets - Array de resultados para rolamento superior HSS da gearbox up wind.
 * - gearboxHSSDownWindDownBearingResultSets - Array de resultados para rolamento inferior HSS da gearbox up wind.
 * - gearboxIMSUpWindBearingResultSets - Array de resultados para rolamento IMS da gearbox down wind.
 * - gearboxIMSDownWindBearingResultSets - Array de resultados para rolamento IMS da gearbox up wind.
 * - gearboxLSSUpWindBearingResultSets - Array de resultados para rolamento LSS da gearbox down wind.
 * - gearboxLSSDownWindUpBearingResultSets - Array de resultados para rolamento superior LSS da gearbox up wind.
 * - gearboxLSSDownWindDownBearingResultSets - Array de resultados para rolamento inferior LSS da gearbox up wind.
 * - gearboxPlanetaryBearingResultSets - Array de resultados para rolamento planetário da gearbox.
 * - gearboxPlanetaryDownWindBearingResultSets - Array de resultados para rolamento planetário da gearbox up wind.
 * - gearboxPlanetaryUpWindBearingResultSets - Array de resultados para rolamento planetário da gearbox down wind.
 * - mainShaftBearingResultSets - Array de resultados para rolamento do eixo principal.
 * - mainShaftUpWindBearingResultSets - Array de resultados para rolamento do eixo principal down wind.
 * - mainShaftDownWindBearingResultSets - Array de resultados para rolamento do eixo principal up wind.
 * @returns {Object} Um objeto contendo todos os piores de resultados.
 */
const WorstResultSetView = function(obj)
{
	return {
		mainResultSetsList:                           obj.mainResultSetsList || new Array(0),
		stage2ResultSets:                             obj.stage2ResultSets || new Array(0),
		stage3ResultSets:                             obj.stage3ResultSets || new Array(0),
		planetaryResultSets:                          obj.planetaryResultSets || new Array(0),
		bearingsResultSets:                           obj.bearingsResultSets || new Array(0),
		loosenessResultSets:                          obj.loosenessResultSets || new Array(0),
		imbalanceMainShaftResultSets:                 obj.imbalanceMainShaftResultSets || new Array(0),
		angularMisalignmentResultSets:                obj.angularMisalignmentResultSets || new Array(0),
		parallelMisalignmentResultSets:               obj.parallelMisalignmentResultSets || new Array(0),
		parallelMisalignmentGeneratorShaftResultSets: obj.parallelMisalignmentGeneratorShaftResultSets || new Array(0),
		generatorShaftUnbalanceResultSets:            obj.generatorShaftUnbalanceResultSets || new Array(0),
		generatorElectricFail:                        obj.generatorElectricFail || new Array(0),
		angularMisalignmentHssResultSets:             obj.angularMisalignmentHssResultSets || new Array(0),
		parallelMisalignmentHssResultSets:            obj.parallelMisalignmentHssResultSets || new Array(0),
		generatorUpWindBearingResultSets:             obj.generatorUpWindBearingResultSets || new Array(0),
		generatorDownWindBearingResultSets:           obj.generatorDownWindBearingResultSets || new Array(0),
		gearboxHSSUpWindBearingResultSets:            obj.gearboxHSSUpWindBearingResultSets || new Array(0),
		gearboxHSSDownWindUpBearingResultSets:        obj.gearboxHSSDownWindUpBearingResultSets || new Array(0),
		gearboxHSSDownWindDownBearingResultSets:      obj.gearboxHSSDownWindDownBearingResultSets || new Array(0),
		gearboxIMSUpWindBearingResultSets:            obj.gearboxIMSUpWindBearingResultSets || new Array(0),
		gearboxIMSDownWindBearingResultSets:          obj.gearboxIMSDownWindBearingResultSets || new Array(0),
		gearboxLSSUpWindBearingResultSets:            obj.gearboxLSSUpWindBearingResultSets || new Array(0),
		gearboxLSSDownWindUpBearingResultSets:        obj.gearboxLSSDownWindUpBearingResultSets || new Array(0),
		gearboxLSSDownWindDownBearingResultSets:      obj.gearboxLSSDownWindDownBearingResultSets || new Array(0),
		gearboxPlanetaryBearingResultSets:            obj.gearboxPlanetaryBearingResultSets || new Array(0),
		gearboxPlanetaryDownWindBearingResultSets:    obj.gearboxPlanetaryDownWindBearingResultSets || new Array(0),
		gearboxPlanetaryUpWindBearingResultSets:      obj.gearboxPlanetaryUpWindBearingResultSets || new Array(0),
		mainShaftBearingResultSets:                   obj.mainShaftBearingResultSets || new Array(0),
		mainShaftUpWindBearingResultSets:             obj.mainShaftUpWindBearingResultSets || new Array(0),
		mainShaftDownWindBearingResultSets:           obj.mainShaftDownWindBearingResultSets || new Array(0),
	};
};

/**
 * Cria uma visão dos conjuntos de resultados com informações padrão.
 *
 * @param {object} obj - O objeto de entrada contendo dados do conjunto de resultados.
 * - {string} Data e hora do conjunto de resultados.
 * - {Object} Conjunto de resultados anterior.
 * - {Object} Novo conjunto de resultados.
 * - {number|null} Potência medida, se disponível.
 * - {string} Unidade de medida da potência.
 * - {number|null} Velocidade do vento, se disponível.
 * - {string} Unidade de medida da velocidade do vento.
 * - {number|null} Referência de fase, se disponível.
 * - {string} Unidade de medida da referência de fase.
 * @returns {object} Um objeto com todos os dados do conjunto de resultados,
 * com valores padrão caso os dados não sejam fornecidos.
 */
const ResultSetView = function(obj)
{
	return {
		dateTime:           obj.formattedDateTime || "",
		newResultSet:       obj.newResultSet || {},
		power:              obj.power ?? null,
		powerUnit:          obj.powerUnit || "",
		windSpeed:          obj.windSpeed ?? null,
		windSpeedUnit:      obj.windSpeedUnit || "",
		phaseReference:     obj.phaseReference ?? null,
		phaseReferenceUnit: obj.phaseReferenceUnit || "",
	};
};
export default {
	FilteredResultSetView,
	ResultSetModel,
	ResultSetsState,
	ResultSetView,
	WorstResultSetView
};